import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, Button } from '@mui/material';
import isGHMC, { formatDayMonthYearTime, getCurrentDateTime, getCurrentDateTime1 } from '../../../Common/helper/helpar';
import { GetAllTertiaryTripReport } from '../../../Apis/userCreationApi';
import Loader from '../../../Common/Loader/loader';
import ExcelJS from 'exceljs';
import { getNowDateTime, getOneMonthPastDateTime } from '../../AssetVehicle/utils/helpers';
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

const TertiaryTripDetails = () => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [fromDate, setFromDate] = useState(getStartOfCurrentDate());
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [toDate, setToDate] = useState(getCurrentDateTime());
  const [dataLoading, setDataLoading] = useState(true);
  const [VehicleNumber, setVehicleNumber] = useState("");
  const isProd = isGHMC();

  


  const fetchData = async (filters = {}) => {
    const queryParams = new URLSearchParams(filters).toString();
    try {
      setDataLoading(true);
      const data = await GetAllTertiaryTripReport(queryParams)

      // Check if data exists and update state
      if (data && data.length > 0) {
        setRows(data); // Store data in rows
        setFilteredRows(data); // Initially, filteredRows are the same as rows
        setDataLoading(false);
      } else {
        setRows([]); // Clear rows if no data
        setFilteredRows([]); // Clear filteredRows
        setDataLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setDataLoading(false);
    }
  };

  // Filter rows based on date range
  const handleFilter = () => {
    const filters = {
      fromDate: fromDate || '',
      toDate: toDate || '',
      VehicleNumber: VehicleNumber || " ",
    };

    fetchData(filters);
  };
  useEffect(() => {
    handleFilter();
  }, []);

  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
    return date.toLocaleString("en-GB", options).replace(",", "");
  };


  const downloadAsExcel = async () => {
    // Prepare data for Excel (filteredRows will be used here)
    const formattedData = filteredRows.map((row, index) => ({
      "S.No": row.sno || index + 1,
      "Vehicle Number": row.vehicleNumber || 'N/A',
      "Driver Name": row.driverName || 'N/A',
      "Departure Station": row.departureTransferStationName || 'N/A',
      "Destination Station": row.destinationTransferStationName || 'N/A',
      "Trip Start Date &Time": row.tripStartDateTime ? formatDayMonthYearTime(row.tripStartDateTime) : 'N/A',
      "Trip End Date &Time": row.tripEndDateTime ? formatDayMonthYearTime(row.tripEndDateTime) : 'N/A',
      "Start Latitude": row.tripStartLatitude || 'N/A',
      "Start Longitude": row.tripStartLongitude || 'N/A',
      "End Latitude": row.tripEndLatitude || 'N/A',
      "End Longitude": row.tripEndLongitude || 'N/A',
      "Start Address": row.beforeAddress || 'N/A',
      "End Address": row.afterAddress || 'N/A',
      "Vehicle ID": row.vehicleId || 'N/A',
      // "Vehicle UUID": row.vehicleUuid || 'N/A',
      "Vehicle Type": row.vehicleTypeName || 'N/A',
      "Owner Type": row.ownerTypeName || 'N/A',
      "Driver Number": row.driverNumber || 'N/A',
      "Driver ID": row.driverId || 'N/A',
      "Container ID": row.containerId || 'N/A',
      "Created By": row.createdBy || 'N/A',
      "Updated By": row.updatedBy || 'N/A',
    }));
  
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tertiary Trip Report");
  
    // Define styles
    const boldFont = { bold: true };
    
    // Add the generation time header
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Tertiary Trip Report Generated on: ${formattedDate}, ${formattedTime}`;
    
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 10);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };
  
    // Add section header
    worksheet.addRow(["", "", `Tertiary Trip Report (${formatDateForDisplay(fromDate)} to ${(toDate)}) (at ${getCurrentDateTime1()})`, ""]);
    worksheet.mergeCells(2, 2, 2, 10);
    worksheet.getCell(2, 2).value = `Tertiary Trip Report (${formatDateForDisplay(fromDate)} to ${(toDate)}) (at ${getCurrentDateTime1()})`;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };
  
    // Add the table header row
    const tableHeaderRow = worksheet.addRow([
      "S.No", "Vehicle Number", "Driver Name", "Departure Station", 
      "Destination Station", "Trip Start Date &Time", "Trip End Date &Time",
      "Start Latitude", "Start Longitude", "End Latitude", "End Longitude", "Start Address", "End Address",
      "Vehicle ID", "Vehicle UUID","Vehicle Type","Owner Type", "Driver Number", "Driver ID", 
      "Container ID", "Created By", "Updated By"
    ]);
  
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 30) {
        // Apply background color to header
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Light red background
        };
      }
    });
  
    // Add data rows
    formattedData.forEach((item, index) => {
      worksheet.addRow([
        item["S.No"], item["Vehicle Number"], item["Driver Name"], item["Departure Station"],
        item["Destination Station"], item["Trip Start Date &Time"], item["Trip End Date &Time"],
        item["Start Latitude"], item["Start Longitude"], item["End Latitude"], item["End Longitude"], item["Start Address"], item["Start Address"],
        item["Vehicle ID"], item["Vehicle UUID"],item["Vehicle Type"],item["Owner Type"], item["Driver Number"], item["Driver ID"],
        item["Container ID"], item["Created By"], item["Updated By"]
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 30) {
          cell.alignment = { horizontal: "left", vertical: 'middle', wrapText: true };
        }
      });
    });
  
    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 }, { width: 15 }, { width: 20 }, { width: 20 },
      { width: 20 }, { width: 25 }, { width: 25 }, { width: 15 },
      { width: 15 }, { width: 15 }, { width: 15 }, { width: 100 },{ width: 100 }, { width: 20 },
      { width: 20 },{ width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 },
      { width: 20 }, { width: 20 }
    ];
  
    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Tertiary_Trip_Report.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 100));
    setPage(0);
  };

  const headerStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }
  const cellStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', whiteSpace: "normal" };
  return (
    <div>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Teritary Trip Report ({formatDateForDisplay(fromDate)} to {(toDate)}) (at {getCurrentDateTime1()})</h4>
            <div className="card">
              <div className="card-body p-3">
                <div className="row align-items-end">
                  <div className="col-md-10"></div>
                  <div className="row" style={{ textAlign: "left" }}>
                    <div className="col-md-3 ">
                      <label>Start Date</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        min={getOneMonthPastDateTime()}
                        max={getNowDateTime()}
                        sx={{ marginRight: '20px' }}
                      />
                    </div>
                    <div className="col-md-3 ">
                      <label>End Date</label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                        min={fromDate}
                        max={getCurrentDateTime()}
                        sx={{ marginRight: '20px' }}
                      />
                    </div>
                    <div className="col-md-3 ">
                    <label>Vehicle Number</label>
                      <input
                        type="text"
                        name="vehicleTypeCode"
                        style={FilterinputStyle}
                        placeholder="Vehicle Number"
                        value={VehicleNumber}
                        onChange={(e) => {
                          setVehicleNumber(e.target.value.replace(/\s+/g, ""));
                        }}
                      />
                    </div>
                    <div className='col-md-3 flex d-flex gap-4 justify-between'>
                    <div>
                      <button variant="contained"
                        className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                        onClick={handleFilter} sx={{ padding: '10px 20px' }}>
                        Search
                      </button>
                    </div>
                    <div className='mt-4'>
                    <button
                    className="btn btn-excel"
                    onClick={downloadAsExcel}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>
                    </div>
                   
                    </div>
                    
                  </div>
                  {dataLoading ? <Loader /> : <Paper sx={{ width: '115%', overflow: 'hidden' }}>
                    <TableContainer
                      component={Paper}
                      sx={{
                        width: '100%',
                        margin: '20px 0',
                        maxHeight: '500px', // Set a maximum height for the container
                        overflowY: 'auto',
                        // Enable vertical scrollbar if needed
                        boxShadow: '0px 3px 6px rgba(0,0,0,0.1)',
                        border: '1px solid #ccc',
                      }}
                    >
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead
                          sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1, // Ensure header stays above other content
                          }}
                        >
                          <TableRow sx={{ paddingTop: '20px' }}>
                            <TableCell sx={headerStyles}>S.No</TableCell>
                            <TableCell sx={headerStyles}>Vehicle Number</TableCell>
                            <TableCell sx={headerStyles}>Driver Name</TableCell>
                            <TableCell sx={headerStyles}>Departure Station</TableCell>
                            <TableCell sx={headerStyles}>Destination Station</TableCell>
                            <TableCell sx={headerStyles}>Trip Start Date &Time</TableCell>
                            <TableCell sx={headerStyles}>Trip End Date &Time</TableCell>
                            <TableCell sx={headerStyles}>Start Latitude</TableCell>
                            <TableCell sx={headerStyles}>Start Longitude</TableCell>
                            <TableCell sx={headerStyles}>End Latitude</TableCell>
                            <TableCell sx={headerStyles}>End Longitude</TableCell>
                            <TableCell sx={headerStyles}>Start Address</TableCell>
                            <TableCell sx={headerStyles}>End Address</TableCell>
                            <TableCell sx={headerStyles}>Vehicle ID</TableCell>
                            {/* <TableCell sx={headerStyles}>Vehicle UUID</TableCell> */}
                            <TableCell sx={headerStyles}>Vehicle Type</TableCell>
                            <TableCell sx={headerStyles}>Owner Type</TableCell>
                            <TableCell sx={headerStyles}>Driver Number</TableCell>
                            <TableCell sx={headerStyles}>Driver ID</TableCell>
                            <TableCell sx={headerStyles}>Container ID</TableCell>
                            <TableCell sx={headerStyles}>Created By</TableCell>
                            <TableCell sx={headerStyles}>Updated By</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredRows.length > 0 ? (
                            filteredRows.map((row, index) => (
                              <TableRow
                                key={row.sno}
                                sx={{
                                  backgroundColor: isProd
                                    ? index % 2 === 0
                                      ? '#8fc9ff'
                                      : '#aed8ff'
                                    : index % 2 === 0
                                      ? '#F8CCCD'
                                      : '#ffeded',
                                  '&:nth-of-type(odd)': { backgroundColor: isProd ? '#aed8ff' : '#ffeded' },
                                  '&:nth-of-type(even)': { backgroundColor: isProd ? '#8fc9ff' : '#F8CCCD' },
                                }}
                              >
                                <TableCell sx={cellStyles}>{row.sno || index + 1}</TableCell>
                                <TableCell sx={cellStyles}>{row.vehicleNumber  || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.driverName || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.departureTransferStationName || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.destinationTransferStationName || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.tripStartDateTime || 'N/A' ?  formatDayMonthYearTime(row.tripStartDateTime || 'N/A') :"NA"}</TableCell>
                                <TableCell sx={cellStyles}>{row.tripEndDateTime || 'N/A' ?  formatDayMonthYearTime(row.tripEndDateTime || 'N/A') : "NA"}</TableCell>
                                <TableCell sx={cellStyles}>{row.tripStartLatitude || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.tripStartLongitude || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.tripEndLatitude || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.tripEndLongitude || 'N/A'}</TableCell>
                                <TableCell sx={{...cellStyles, minWidth: 300}}>{row.beforeAddress || 'N/A'}</TableCell>
                                <TableCell sx={{...cellStyles, minWidth: 300}}>{row.afterAddress || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.vehicleId || 'N/A'}</TableCell>
                                {/* <TableCell sx={cellStyles}>{row.vehicleUuid || 'N/A'}</TableCell> */}
                                <TableCell sx={cellStyles}>{row.vehicleTypeName || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.ownerTypeName || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.driverNumber || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.driverId || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.containerId || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.createdBy || 'N/A'}</TableCell>
                                <TableCell sx={cellStyles}>{row.updatedBy || 'N/A'}</TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={20} sx={{ textAlign: 'center' }}>No data available</TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      component="div"
                      count={filteredRows.length}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const FilterinputStyle = {
  height: "38px",
  borderRadius: "4px",
  border: "1px solid #ced4da",
  paddingLeft: "10px",
  width: "100%",
};

export default TertiaryTripDetails;







